export class ValidationErrorDto {
  field: string;
  message: string;
}

export class ValidateRegistrationCredentialsResultDto {
  isValid: boolean;
  errors: ValidationErrorDto[];

  getEmailError(): string | null {
    return this.errors?.find((e) => e.field === 'email')?.message || null;
  }

  getPasswordError(): string | null {
    return this.errors?.find((e) => e.field === 'password')?.message || null;
  }

  hasEmailError(): boolean {
    return this.errors?.some((e) => e.field === 'email') || false;
  }

  hasPasswordError(): boolean {
    return this.errors?.some((e) => e.field === 'password') || false;
  }
}
